import diceCss from '../../../dice/dice.module.css';
import css from './commone.module.css';

export type LinkStyle = {
	/** класс с цветом ссылки */
	className: string;
	/** заклинания в тексте набраны курсивом */
	italic?: boolean;
};

/** вид ссылки → как она выглядит. Одна таблица и для страницы, и для редактора: иначе цвета разъезжаются */
const LINK_STYLES: Record<string, LinkStyle> = {
	spell: {className: css.violetLink, italic: true},
	item: {className: css.brawnLink},
	'magic-item': {className: css.blueLink},
	monster: {className: css.redLink},
	feat: {className: css.yellowLink},
	feature: {className: css.yellowLink},
	term: {className: css.softLink},
	creatureType: {className: css.softLink},
	size: {className: css.softLink},
	condition: {className: css.softLink},
	action: {className: css.softLink},
	skill: {className: css.softLink},
	dice: {className: diceCss.dicePlugin},
	wiki: {className: css.wikiLink},
};

export function linkStyle(kind: string): LinkStyle {
	return LINK_STYLES[kind] ?? {className: css.blueLink};
}

export function linkClass(kind: string) {
	return linkStyle(kind).className;
}
